<template>
  <div class="annual-norm text-dark">
    <div class="d-header">
      <div class="d-header__left">
        <h1>Arbeidstidsplan</h1>
        <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
      </div>
    </div>
    <Loader v-if="isLoading && !isUpdatingTasks"></Loader>
    <template v-else>
      <div class="d-tabs">
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': !viewIsResult}" @click="viewIsResult = false">
          Arbeidsåret
        </div>
        <!--
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': viewIsResult}" @click="viewIsResult = true">
          Se opgørelse
        </div>
        -->
      </div>
      <div class="d-tabs__container">
        <!-- OPGØRELSE -->
        <template v-if="viewIsResult">
          <AnnualNormResult
            :schoolId="schoolId"
            :users="userWithProps">
          </AnnualNormResult>
        </template>
        <div class="annual-norm__body" v-else>
          <div class="annual-norm__body__left">
            <ArbeidsplanAssignHoursNorm
              class="marg-1-bottom"
              @updateUsersHours="readAssignedHours">
            </ArbeidsplanAssignHoursNorm>
            <ul>
              <li v-for="user in userWithProps"
                  :key="user.user_calendar_id"
                  :class="{'user-item--active': user.v_is_active_user}"
                  class="user-item">
                <div class="user-item__body" @click="setActiveUserId(user.id)">
                  <div class="user-item__name">
                    <img class="user-item__name__img" v-if="user.default_thumb_url" :src="user.default_thumb_url">
                    <p>{{ user.name }}</p>
                  </div>
                  <div class="user-item__right">
                    <div class="user-item__hours">
                      <p><label class="d-label">Årsverk</label><span>{{ user.v_assigned_total_hours }}</span></p>
                      <p><label class="d-label">Undervisning</label><span>{{
                          user.v_total_teaching_percentage_label
                        }}</span></p>
                      <p><label class="d-label">Oppgaver</label><span>{{ user.v_user_tasks_hours_label }}</span></p>
                    </div>
                    <div class="user-item__arrow">
                      <span class="icon-arrow-right4" v-if="!user.v_is_active_user"></span>
                      <span class="icon-arrow-down4" v-else></span>
                    </div>
                  </div>
                </div>
                <ArbeidsplanUser v-if="user.v_is_active_user" :user="activeUser" :activeNorm="activeNorm"
                                 :activeNormFormatted="activeNormFormatted"></ArbeidsplanUser>
              </li>
            </ul>
          </div>
          <div class="annual-norm__body__right">
            <div class="annual-norm__body__right__header">
              <div class="flipper-buttons">
                <button @click="isTasksView = false"
                        class="flipper-buttons__button"
                        :class="{'active': !isTasksView}">
                  <span class="icon-year-planning"></span>
                  Fag
                </button>
                <button @click="isTasksView = true"
                        class="flipper-buttons__button"
                        :class="{'active': isTasksView}">
                  <span class="icon-file-text"></span>
                  Oppgaver
                </button>
              </div>
            </div>
            <ArbeidsplanSubjects v-if="!isTasksView"
                                 @setIsCreate="setIsCreateSubject"
                                 @setEditSubject="setEditSubject">
            </ArbeidsplanSubjects>
            <SubjectsDistributionTasks v-if="isTasksView">
            </SubjectsDistributionTasks>
          </div>
        </div>
      </div>
    </template>
    <CreateSubjectForm
      v-if="isSubjectModal"
      :showModal="isSubjectModal"
      :initCalendarId="activeCalendarId"
      :editSubject="theEditSubject"
      :editSubjectId="theEditSubjectId"
      @close="closeSubjectModal"
      @createSubject="createNewSubject"
      @updateSubject="updateSubject"
      @deleteSubject="deleteSubject">
    </CreateSubjectForm>
    <transition name="d-modal">
      <ModalConfirmation
        v-if="isConfirmDeletion"
        :showClose="false"
        @close="$store.commit('setConfirmDeletion', false)"
        @confirm="confirmDelete">
        <h3 slot="item" style="padding: 1rem 1rem 0 1rem">{{ itemToDelete.name }}</h3>
      </ModalConfirmation>
    </transition>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import Loader from '../common/Loader'
import ArbeidsplanSubjects from './ArbeidsplanSubjects.vue'
import ArbeidsplanAssignHoursNorm from './ArbeidsplanAssignHoursNorm.vue'
import docendo from '../../docendo'
import ModalConfirmation from '../Modals/ModalConfirmation'
import AnnualNormResult from './AnnualNormResult'
import moment from 'moment'
import SubjectsDistributionTasks from '../SubjectsDistribution/SubjectsDistributionTasks.vue'
import SubjectsDistributionUserAgreements from '../SubjectsDistribution/SubjectsDistributionUserAgreements.vue'
import ArbeidsplanUser from './ArbeidsplanUser.vue'
import CreateSubjectForm from '../Subjects/CreateSubjectForm.vue'

export default {
  components: {
    CreateSubjectForm,
    ArbeidsplanUser,
    SubjectsDistributionUserAgreements,
    SubjectsDistributionTasks,
    AnnualNormResult,
    ModalConfirmation, ArbeidsplanAssignHoursNorm, ArbeidsplanSubjects, Loader, ChangeSchoolYear
  },
  data () {
    return {
      theEditSubject: null,
      theEditSubjectId: null,
      activeCalendar: null,
      isSubjectModal: false,
      viewIsResult: false,
      isTasksView: false,
      activeUserId: null,
      allVacationsDays: [],
      isUpdatingTasks: false,
      activeNorm: null,
      activeUserAgreements: ''
    }
  },
  computed: {
    activeCalendarId () {
      return this.activeCalendar ? this.activeCalendar.id : null
    },
    activeNormFormatted () {
      const norm = this.activeNorm ? this.activeNorm : []
      return norm.filter(item => !item.title.startsWith('hidden_')).map(item => ({
        ...item,
        value: item.title === 'Periode start' || item.title === 'Periode slut' ? moment(item.value).format('ll') : item.value
      }))
    },
    activeUser () {
      return this.userWithProps.find(user => user.id === this.activeUserId)
    },
    calendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    isConfirmDeletion () {
      return this.$store.state.subjects.isConfirmDeletion
    },
    itemToDelete () {
      return this.$store.state.subjects.itemToDelete
    },
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    subjects () {
      return this.$store.state.subjects.subjects
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasksInHash () {
      return this.$store.getters.tasksInHash
    },
    tasksInUserHash () {
      return this.$store.getters.tasksInUserHash
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersAssignedHoursHash () {
      return this.$store.getters.usersAssignedHoursHash
    },
    userWithProps () {
      return this.users.map(user => {
        const userInHash = this.usersAssignedHoursHash[user.id]
        const isActiveUser = user.id === this.activeUserId

        // Tasks
        const userTasksIds = this.tasksInUserHash[user.user_calendar_id] ? this.tasksInUserHash[user.user_calendar_id] : []
        const userAllTypeTasks = userTasksIds.map(id => this.tasksInHash[id])
        const tasks = []
        let tasksHours = 0

        const teachingTasks = []
        let teachingTaskHours = 0
        userAllTypeTasks.forEach(task => {
          if (task.subject_type === 'additional_tasks') {
            tasks.push({...task, v_hours_label: (task.hours * 1).toFixed(2)})
            tasksHours += task.hours * 1
          } else if (task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject') {
            teachingTasks.push(task)
            teachingTaskHours += task.hours * 1
          }
        })
        let assignedTotalHours = 0
        if (userInHash && userInHash.assigned_total_hours) {
          assignedTotalHours = userInHash.assigned_total_hours
        }
        // SUBJECTS
        let userSubjectsWithAarsramme = []
        const userSubjectsWithIds = this.subjectsInUserHash[user.user_calendar_id]
        let userSubjects = []
        if (userSubjectsWithIds) {
          userSubjects = userSubjectsWithIds.map(id => this.subjectsInHash[id])
        }
        userSubjects = userSubjects.concat(teachingTasks)
        let userSubjectHours = 0
        const userNorm = userInHash && userInHash['norm'] && userInHash['norm'].length > 0 ? userInHash['norm'] : []
        const sumOfTeachingReduction = userNorm.filter(item => item.value && item.title.startsWith('hidden_reduction_teaching')).reduce((accumulator, item) => accumulator + item.value, 0)
        let totalTeachingPercentage = sumOfTeachingReduction
        userSubjectsWithAarsramme = userSubjects.map(subject => {
          userSubjectHours += subject.hours * 1
          const subjectPreptime = subject.preparation ? subject.preparation : 741
          const calendarName = subject.calendar_id !== user.user_calendar_id ? this.calendarsInHash[subject.calendar_id] ? this.calendarsInHash[subject.calendar_id]['name'] : '' : ''
          const teachingPercentage = ((subject.hours * 1) / subjectPreptime) * 100
          totalTeachingPercentage += teachingPercentage
          return {
            ...subject,
            v_calendar: calendarName,
            v_percentage: teachingPercentage,
            v_percentage_label: teachingPercentage.toFixed(2) + '%',
            v_hours_label: (subject.hours * 1).toFixed(2)
          }
        })

        // Create a new object with the original user properties and the new v_assigned_total_hours property
        return {
          ...user,
          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
          v_total_teaching_percentage: totalTeachingPercentage,
          v_total_teaching_percentage_label: totalTeachingPercentage.toFixed(2) + '%',
          v_is_active_user: isActiveUser,
          v_user_tasks: tasks,
          v_user_tasks_hours: tasksHours,
          v_user_tasks_hours_label: parseFloat(tasksHours).toFixed(2),
          v_user_subjects: userSubjectsWithAarsramme,
          v_user_subjects_hours: userSubjectHours,
          v_user_subjects_hours_label: parseFloat(userSubjectHours).toFixed(2)
        }
      })
    }
  },
  watch: {
    activeSchoolYear () {
      this.readAssignedHours()
      this.readSubjects()
      this.$store.dispatch('readTasks', this.activeSchoolYear.id)
    }
  },
  methods: {
    setEditSubject (editSubject) {
      this.theEditSubject = Object.assign({}, editSubject)
      this.theEditSubjectId = editSubject.id
      this.isSubjectModal = true
    },
    createNewSubject (newSubject) {
      newSubject['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('createSubject', newSubject)
      this.closeSubjectModal()
    },
    closeSubjectModal () {
      this.activeCalendar = null
      this.isSubjectModal = false
      this.theEditSubject = null
      this.theEditSubjectId = null
    },
    setIsCreateSubject (calendar) {
      this.activeCalendar = calendar
      this.isSubjectModal = true
    },
    updateSubject (updatedSubject) {
      this.$store.dispatch('updateSubject', updatedSubject)
      this.closeSubjectModal()
    },
    deleteSubject (editSubject) {
      this.$store.dispatch('deleteSubject', editSubject)
      this.closeSubjectModal()
    },
    readSubjects () {
      this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
    },
    readTasks () {
      this.$store.dispatch('readTasks', this.activeSchoolYear.id)
    },
    updateTasksFromServer () {
      this.isUpdatingTasks = true
      this.readTasks()
    },
    readAssignedHours () {
      const schoolObj = {
        schoolId: this.schoolId,
        schoolYearId: this.activeSchoolYear.id
      }
      this.$store.dispatch('getUsers', this.schoolId, null)
      this.$store.dispatch('readUsersAssignedHours', schoolObj)
      if (this.activeUserId) {
        this.readUserNorm(this.activeUserId)
      }
    },
    readUserNorm (userId) {
      this.activeNorm = ''
      this.activeUserAgreements = ''
      docendo.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, success => {
        this.activeNorm = success.norm ? success.norm : []
        this.activeUserAgreements = success.agreements ? success.agreements : ''
        console.log('readUserNorm', success)
      }, failure => {
        console.log('failed!')
      })
    },
    setActiveUserId (userId) {
      if (this.activeUserId === userId) {
        this.activeUserId = null
      } else {
        this.readUserNorm(userId)
        this.activeUserId = userId
      }
    },
    getSchoolDays () {
      docendo.schoolVacationDaysRead(this.schoolId, success => {
        this.allVacationsDays = success
      }, failure => {
        console.log('failure')
      })
    },
    confirmDelete () {
      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
        this.$store.dispatch('deleteTask', this.itemToDelete)
        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id)
      }
      this.$store.commit('setConfirmDeletion', false)
      this.$store.commit('setItemToDelete', null)
    },
    setUpdatingFromServer () {
      this.isUpdatingTasks = false
    }
  },
  mounted () {
    this.readAssignedHours()
    this.getSchoolDays()
    window.addEventListener('vueCRUDSubject', () => this.updateTasksFromServer())
    window.addEventListener('vueDoneLoadingTasks', () => this.setUpdatingFromServer())
  },
  beforeDestroy () {
    window.removeEventListener('vueDoneLoadingTasks', () => this.setUpdatingFromServer())
    window.removeEventListener('vueCRUDSubject', () => this.updateTasksFromServer())
  }
}
</script>

<style scoped>

.annual-norm {
  max-width: 1680px;
  margin: 0 auto;
  padding: 0 1rem;
}

.d-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-header__left {
  display: flex;
  align-items: center;
}

.d-header__left > h1 {
  margin-right: 1rem;
}

.flipper-buttons {
  display: flex;
  justify-content: flex-end;
}

.flipper-buttons__button {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: rgba(44, 62, 80, 0.65);
  height: 38px;
  min-width: 130px;
  margin: 0;
  border-radius: 0;
}

.flipper-buttons__button:first-child {
  border-radius: 3px 0 0 3px;
}

.flipper-buttons__button:nth-child(2) {
  border-radius: 0 3px 3px 0;
}

.flipper-buttons__button.active {
  background-color: white;
  color: #2c3e50;
  border: none;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.flipper-buttons__button.active > span {
  color: var(--blue);
}

.flipper-buttons__button span {
  margin-right: 10px;
}

.annual-norm__body {
  display: flex;
  gap: 1rem;
}

.annual-norm__body__left {
  max-width: 350px;
  min-width: 350px;
}

.annual-norm__body__right {
  width: 100%;
}

.user-item {
  margin-bottom: 4px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background-color: #ffffff;
  border-radius: 4px;
  padding: 4px 8px;
  transition: transform 0.25s;
}

.user-item:hover:not(.user-item--active) {
  transform: scale(1.02);
}

.user-item__body {
  display: flex;
  justify-content: space-between;
}

.user-item .icon-arrow-down4 {
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.user-item.user-item--is-open {
  background: #fff !important;
  cursor: default;
}

ul.users-list > li.user-item:hover:not(.user-item__header) {
  background-color: #f6f9fc;
}

.user-item__name {
  display: flex;
  align-items: center;
}

.user-item__name__img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 5px;
}

.user-item__name span {
  font-size: 10px;
}

.user-item__hours {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-item__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
}

.user-item__hours > p {
  display: flex;
  align-items: center;
}

.user-item__hours > p > label {
  margin-bottom: 0;
}

.user-item__hours > p > span {
  font-weight: bold;
  width: 50px;
  text-align: right;
}

.user-item__right {
  display: flex;
}

.d-tabs {
  display: flex;
  align-items: stretch;
}

.d-tabs__tab {
  border-radius: 4px 4px 0 0;
  padding: 1rem 2rem;
  margin-bottom: -1px;
  margin-right: 0;
  font-weight: 700;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  background: #edf0f5;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0;
  color: #6772e5;
}

.d-tabs__container {
  padding: 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// Arbeidsplan.vue?174b5ab7